import React from "react";
import { Link, NavLink } from "react-router-dom";

const Navbar = () => {
  const linkClass = ({ isActive }) =>
    `nav-link fw-semibold ${isActive ? "active" : ""}`;

  const token = localStorage.getItem("User_Token");

  return (
    <nav className="navbar navbar-expand-lg bg-white py-3 shadow-sm fixed-top">
      <div className="container">
        {/* Logo */}
        <NavLink
          to="/"
          className="navbar-brand d-flex align-items-center gap-2 fw-bold"
        >
          <img
            src="/assets/img/ab_book_logo.png"
            alt="AssistBook"
            style={{ height: "3.5rem" }}
          />
        </NavLink>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#homeNavbar"
          aria-controls="homeNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Menu */}
        <div className="collapse navbar-collapse" id="homeNavbar">
          <ul className="navbar-nav mx-auto mb-2 mb-lg-0 gap-lg-4">
            <li className="nav-item">
              <NavLink to="/" end className={linkClass}>
                Home
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/features" className={linkClass}>
                Features
              </NavLink>
            </li>

            {/* Solution Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle fw-semibold"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Solution
              </a>

              <ul className="dropdown-menu mega-menu p-4">
                <div className="row">
                  {/* Left Column */}
                  <div className="col-12 col-lg-6">
                    <li>
                      <NavLink
                        to="/features#inventory"
                        className="dropdown-item d-flex align-items-center gap-2"
                      >
                        <i className="bi bi-box text-primary"></i>
                        Inventory Management
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item d-flex align-items-center gap-2"
                        to="/features#services"
                      >
                        <i className="bi bi-briefcase text-primary"></i>
                        Services Management
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item d-flex align-items-center gap-2"
                        to="/features#sales"
                      >
                        <i className="bi bi-cart text-primary"></i>
                        Sales & Order Management
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item d-flex align-items-center gap-2"
                        to="/features#purchase"
                      >
                        <i className="bi bi-bag text-primary"></i>
                        Purchase & Order Management
                      </NavLink>
                    </li>
                  </div>

                  {/* Right Column */}
                  <div className="col-12 col-lg-6">
                    <li>
                      <NavLink
                        className="dropdown-item d-flex align-items-center gap-2"
                        to="/features#expenses"
                      >
                        <i className="bi bi-currency-dollar text-primary"></i>
                        Expense Management
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item d-flex align-items-center gap-2"
                        to="/features#returns"
                      >
                        <i className="bi bi-arrow-counterclockwise text-primary"></i>
                        Purchase & Sale Returns
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item d-flex align-items-center gap-2"
                        to="/features#transactions"
                      >
                        <i className="bi bi-journal-check text-primary"></i>
                        Transaction & Ledger
                      </NavLink>
                    </li>

                    <li>
                      <NavLink
                        className="dropdown-item d-flex align-items-center gap-2"
                        to="/features#reports"
                      >
                        <i className="bi bi-bar-chart text-primary"></i>
                        Business Reports & Exports
                      </NavLink>
                    </li>
                  </div>
                </div>
              </ul>
            </li>

            {/* Industry Dropdown */}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle fw-semibold"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Industry
              </a>
              <ul className="dropdown-menu mega-menu p-4">
                <div className="row">
                  {[
                    { id: "retail", name: "Retail", icon: "bi-shop" },
                    { id: "jewellery", name: "Jewellery", icon: "bi-building" },
                    { id: "clothing", name: "Clothing", icon: "bi-truck" },
                    { id: "grocery", name: "Grocery", icon: "bi-people" },
                    {
                      id: "restaurant",
                      name: "Restaurant",
                      icon: "bi-person-badge",
                    },
                    {
                      id: "pharmacy",
                      name: "Pharmacy",
                      icon: "bi bi-bar-chart text-primary",
                    },
                  ].map((item, i) => (
                    <div className="col-12 col-lg-6" key={i}>
                      <li>
                        <NavLink
                          to={`/industry/${item.id}`}
                          className="dropdown-item d-flex align-items-center gap-2"
                        >
                          <i className={`bi ${item.icon} text-primary`}></i>
                          {item.name}
                        </NavLink>
                      </li>
                    </div>
                  ))}
                </div>
              </ul>

              {/* <ul className="dropdown-menu mega-menu p-4">
                <div className="row">
                  <div className="col-6">
                    <NavLink
                      to="/billing-software-for-retail-shop"
                      className="dropdown-item d-flex align-items-center gap-2"
                    >
                      <i className="bi bi-shop-window text-primary"></i>
                      Retail
                    </NavLink>

                    {[
                      { id: "pharmacy", name: "Pharmacy", icon: "bi-capsule" },
                      {
                        id: "grocery-store",
                        name: "Grocery",
                        icon: "bi-basket",
                      },
                    ].map((item, i) => (
                      <li key={i}>
                        <NavLink
                          to={`/billing-software-for-retail-shop/${item.id}`}
                          className="dropdown-item d-flex align-items-center gap-2"
                        >
                          <i className={`bi ${item.icon} text-primary`}></i>
                          {item.name}
                        </NavLink>
                      </li>
                    ))}
                  </div>

                  <div className="col-6">
                    <NavLink
                      to="/restaurant-billing-software"
                      className="dropdown-item d-flex align-items-center gap-2"
                    >
                      <i className="bi bi-shop-window text-primary"></i>
                      Restaurant
                    </NavLink>

                    {[
                      {
                        id: "jewellery-shop",
                        name: "Jewellery",
                        icon: "bi-gem",
                      },
                      { id: "clothing-shop", name: "Clothing", icon: "bi-bag" },
                    ].map((item, i) => (
                      <li key={i}>
                        <NavLink
                          to={`/billing-software-for-retail-shop/${item.id}`}
                          className="dropdown-item d-flex align-items-center gap-2"
                        >
                          <i className={`bi ${item.icon} text-primary`}></i>
                          {item.name}
                        </NavLink>
                      </li>
                    ))}
                  </div>
                </div>
              </ul> */}
            </li>

            <li className="nav-item">
              <NavLink to="/pricing" className={linkClass}>
                Pricing
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/partner" className={linkClass}>
                Partner
              </NavLink>
            </li>
          </ul>

          {/* Right Button */}
          <div className="d-flex align-items-center gap-3">
            <Link
              to={token ? "/dashboard" : "/login"}
              className="btn cta-btn cta-btn-primary text-white text-nowrap"
            >
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
